export default "__VITE_ASSET__GYrsNiQcdpKaWykKe2xG4Q__";